// @flow
import type { DispatchProps, StateProps } from './AddMoneyWithCreditCard';
import AddMoneyWithCreditCard from './AddMoneyWithCreditCard';
import { compose, withProps } from 'react-recompose';
import { getFormValues, reduxForm } from 'redux-form';
import I18n from '../../lib/i18n';
import type { StateType } from '../../modules/reducers';
import ValidationService from '../../lib/validation';
import { addMoney } from '../../modules/AddMoney';
import { connect } from 'react-redux';
import config from '../../config';
import { balanceSelector, customPaymentMeanSelector } from '../../modules/Customer/selectors';
import { getVisibleNumbers } from '../TopUp/lib';
import isEqual from 'lodash/isEqual';
import { isLoadingSelector } from '../../modules/LoadingStatus';
import FormatService from '../../lib/format';

const { minPremiumAmount, maxPremiumAmount } = config;

const validate = ({ amount }) => ({
  amount: ValidationService.validateAddMoney(amount, minPremiumAmount, maxPremiumAmount),
});

const shouldError = ({ nextProps, props, initialRender }) => {
  if (initialRender) {
    return false;
  }
  if (isEqual(props, nextProps)) {
    return false;
  }
  const { amount: nextAmount } = nextProps;

  return nextAmount ? nextAmount.amount.length >= 1 : false;
};

const mapStateToProps = (state: StateType): StateProps => ({
  isLoading: isLoadingSelector(state, 'addMoney'),
  amount: getFormValues('addMoneyWithCreditCardForPremium')(state),
  paymentMean: customPaymentMeanSelector(state),
  walletBalance: balanceSelector(state),
});

const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
  onSubmit: values => {
    dispatch(addMoney(values.amount, 'PREMIUM'));
  },
});

const getModalBody = (amount: string, paymentMean?: Object, walletBalance?: number) => {
  const amountToCents = Number(amount.replace(',', '.')) * 100;

  if (walletBalance && walletBalance - amountToCents >= 0) {
    return I18n.t('Dashboard.AddMoneyWithCreditCard.premium.modal.modalBody.wallet', {
      amount: FormatService.formatCentsToCurrency(amountToCents, true),
    });
  }

  return I18n.t('Dashboard.AddMoneyWithCreditCard.premium.modal.modalBody.creditCard', {
    amount: FormatService.formatCentsToCurrency(amountToCents, true),
    cardNumber: getVisibleNumbers(paymentMean?.functionalId),
  });
};

const withPremiumProps = ({ paymentMean, walletBalance }) => ({
  currentBalanceText: I18n.t('Dashboard.AddMoneyWithCreditCard.premium.currentBalance'),
  amountPlaceholder: FormatService.formatCentsToCurrency(0),
  confirmText: I18n.t('Dashboard.AddMoneyWithCreditCard.premium.confirm'),
  getModalBody: (amount: string) => getModalBody(amount, paymentMean, walletBalance),
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'addMoneyWithCreditCardForPremium',
    validate,
    shouldError,
  }),
  withProps(withPremiumProps)
);
export default enhance(AddMoneyWithCreditCard);
